import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";

// eslint-disable-next-line unicorn/filename-case
var isIOS = function isIOS() {
  return navigator.userAgent.includes("iPhone") || navigator.userAgent.includes("iPad");
};

export default isIOS;